module.exports = __webpack_public_path__ + "/img/844684479f7ca465e89351e5925f7d92.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/common-icon-search01.png
 ** module id = 15
 ** module chunks = 0 4 5
 **/